<mat-dialog-content>
    <div [style.display]="adding ? 'none' : null">
        <app-content-grid #grid [selectMode]="selectMode" [selectedContentId]="selectedContentId" [title]="title" [inset]="true"></app-content-grid>
    </div>
    <mat-spinner *ngIf="adding"></mat-spinner>
</mat-dialog-content>

<mat-dialog-actions *ngIf="!adding">
    <div fxLayoutGap="1rem" fxLayout="row" fxLayoutAlign="end" fxFlexFill>
        <button mat-stroked-button color="warn" class="small" (click)="cancel()" type="button">Cancel</button>
        <button mat-flat-button color="primary" class="small" (click)="select()" type="button">{{selectButtonText}}</button>
    </div>
</mat-dialog-actions>